// extracted by mini-css-extract-plugin
module.exports = {"sidebarMainLink":"sidebarnavlink_sidebarMainLink__2laM5","sidebarLinkActive":"sidebarnavlink_sidebarLinkActive__3cWPN","sidebarLinkIcon":"sidebarnavlink_sidebarLinkIcon__275LB"};